const ARCHIVE_EXTENSION = '.journeynodes';

export function ensureArchiveFileName(input: string): string {
  const trimmed = input.trim();
  const withoutExtension = trimmed.toLowerCase().endsWith(ARCHIVE_EXTENSION)
    ? trimmed.slice(0, -ARCHIVE_EXTENSION.length)
    : trimmed;
  const baseName = withoutExtension.replace(/[^a-z0-9-_]+/gi, '-').replace(/^-+|-+$/g, '');

  return `${baseName || 'journeynodes'}${ARCHIVE_EXTENSION}`;
}

export function archiveFileNameFromTitle(title: string): string {
  return ensureArchiveFileName(title);
}